import { SpecialPriceType } from '../graphql'
import { TimeRange } from './BookableItem'
import Price from './Price'
import { Interval, Promotion } from './Product'

interface PriceTableItemInterface {
  name: string
  singlePrice: Price | null
  amount: number
  totalPrice: Price | null
}

interface PriceTableItemBasic extends PriceTableItemInterface {
  __typename: 'PriceTableItemBasic'
}

interface PriceTableItemAddon extends PriceTableItemInterface {
  __typename: 'PriceTableItemAddon'
}

interface PriceTableItemVoucher extends PriceTableItemInterface {
  __typename: 'PriceTableItemVoucher'
  code: string
}

export interface PriceTableItemMembership extends PriceTableItemInterface {
  __typename: 'PriceTableItemMembership'
  recurringPrice: Price
  partialPriceTimeRange: TimeRange | null
  paymentInterval: Interval | null
  promotion: Promotion | null
}

export interface PriceTableItemBudget extends PriceTableItemInterface {
  __typename: 'PriceTableItemBudget'
  budgetName: string
  corporateName: string
}

export interface PriceTableItemSpecialPrice extends PriceTableItemInterface {
  __typename: 'PriceTableItemSpecialPrice'
  specialPriceType: SpecialPriceType
}

export const isPriceTableOfType =
  <P extends Partial<PriceTableItem>, T extends PriceTableItem['__typename']>(type: T) =>
  (item: P): item is P & { __typename: T } =>
    item.__typename === type

export type PriceTableItem =
  | PriceTableItemBasic
  | PriceTableItemAddon
  | PriceTableItemVoucher
  | PriceTableItemMembership
  | PriceTableItemBudget
  | PriceTableItemSpecialPrice
